import React from 'react';
import { usePageTitle } from '../lib/usePageTitle';
import PageWithNavbar from '../components/PageWithNavbar';

export default function PrivacyPolicyPage() {
  usePageTitle('Privacy Policy');

  return (
    <PageWithNavbar>
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '40px 20px', lineHeight: 1.6 }}>
        <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 32, color: '#2563eb' }}>
          Privacy Policy
        </h1>
        
        <p style={{ marginBottom: 24, color: '#666' }}>
          <strong>Last updated:</strong> {new Date().toLocaleDateString()}
        </p>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16, color: '#333' }}>
            Information We Collect
          </h2>
          <p style={{ marginBottom: 16, color: '#555' }}>
            T.A. Trussell Management, LLC collects information you provide directly to us, such as when you create an account, 
            add family members, input preferences, or contact us for support.
          </p>
          <ul style={{ marginLeft: 20, marginBottom: 16, color: '#555' }}>
            <li style={{ marginBottom: 8 }}>Account information (email, name)</li>
            <li style={{ marginBottom: 8 }}>Family member profiles and preferences</li>
            <li style={{ marginBottom: 8 }}>Address information for gift delivery</li>
            <li style={{ marginBottom: 8 }}>Gift preferences and occasion data</li>
            <li style={{ marginBottom: 8 }}>Usage data and interaction patterns</li>
          </ul>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16, color: '#333' }}>
            How We Use Your Information
          </h2>
          <p style={{ marginBottom: 16, color: '#555' }}>
            We use the information we collect to:
          </p>
          <ul style={{ marginLeft: 20, marginBottom: 16, color: '#555' }}>
            <li style={{ marginBottom: 8 }}>Provide personalized gift recommendations</li>
            <li style={{ marginBottom: 8 }}>Send timely reminders for important occasions</li>
            <li style={{ marginBottom: 8 }}>Improve our AI recommendation algorithms</li>
            <li style={{ marginBottom: 8 }}>Communicate with you about your account and our services</li>
            <li style={{ marginBottom: 8 }}>Ensure the security and integrity of our platform</li>
          </ul>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16, color: '#333' }}>
            Information Sharing
          </h2>
          <p style={{ marginBottom: 16, color: '#555' }}>
            We do not sell, trade, or otherwise transfer your personal information to third parties except:
          </p>
          <ul style={{ marginLeft: 20, marginBottom: 16, color: '#555' }}>
            <li style={{ marginBottom: 8 }}>With trusted service providers who assist in operating our platform (e.g., OpenAI for gift recommendations, Walmart API for product searches)</li>
            <li style={{ marginBottom: 8 }}>When required by law or to protect our rights</li>
            <li style={{ marginBottom: 8 }}>With your explicit consent</li>
          </ul>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16, color: '#333' }}>
            Data Security
          </h2>
          <p style={{ marginBottom: 16, color: '#555' }}>
            We implement appropriate security measures to protect your personal information against unauthorized 
            access, alteration, disclosure, or destruction. This includes encryption of sensitive data, 
            secure authentication methods, and regular security assessments.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16, color: '#333' }}>
            Social Login
          </h2>
          <p style={{ marginBottom: 16, color: '#555' }}>
            When you log in using Google or Facebook, we only access basic profile information (name, email) 
            necessary to create and maintain your account. We do not access your social media posts, 
            friends lists, or other social data.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16, color: '#333' }}>
            Cookies and Tracking
          </h2>
          <p style={{ marginBottom: 16, color: '#555' }}>
            We use essential cookies to maintain your login session and remember your preferences. 
            We do not use third-party tracking cookies or advertising cookies.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16, color: '#333' }}>
            Your Rights
          </h2>
          <p style={{ marginBottom: 16, color: '#555' }}>
            You have the right to:
          </p>
          <ul style={{ marginLeft: 20, marginBottom: 16, color: '#555' }}>
            <li style={{ marginBottom: 8 }}>Access, update, or delete your personal information</li>
            <li style={{ marginBottom: 8 }}>Export your data in a portable format</li>
            <li style={{ marginBottom: 8 }}>Opt out of non-essential communications</li>
            <li style={{ marginBottom: 8 }}>Request information about how we process your data</li>
          </ul>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16, color: '#333' }}>
            Changes to This Policy
          </h2>
          <p style={{ marginBottom: 16, color: '#555' }}>
            We may update this privacy policy from time to time. We will notify you of any material 
            changes by posting the new policy on this page and updating the "Last updated" date.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16, color: '#333' }}>
            Contact Us
          </h2>
          <p style={{ marginBottom: 16, color: '#555' }}>
            If you have any questions about this privacy policy, please contact us through your account 
            settings or by reaching out to our support team.
          </p>
        </section>
      </div>
    </PageWithNavbar>
  );
}